
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const NossosProjetosPage = lazy(() => import('../pages/nossos-projetos/page'));
const TrabalhoDetalhePage = lazy(() => import('../pages/trabalho-detalhe/page'));
const HistoriaPage = lazy(() => import('../pages/historia/page'));
const TrabalheConoscoPage = lazy(() => import('../pages/trabalhe-conosco/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/nossos-projetos',
    element: <NossosProjetosPage />,
  },
  {
    path: '/trabalho-detalhe',
    element: <TrabalhoDetalhePage />,
  },
  {
    path: '/historia',
    element: <HistoriaPage />,
  },
  {
    path: '/trabalhe-conosco',
    element: <TrabalheConoscoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
